import React, { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom'; // ← IMPORTANT: Import from react-router-dom

const Navigation = () => {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const location = useLocation(); // ← Get current location

  // Handle scroll effect
  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  // Close mobile menu when route changes
  useEffect(() => {
    setIsMobileMenuOpen(false);
  }, [location]);

  // ← CHANGED: Use 'path' instead of 'href'
  const navLinks = [
    { name: 'Home', path: '/' },
    { name: 'About', path: '/about' },
    { name: 'Skills', path: '/skills' },
    { name: 'Projects', path: '/projects' },
    { name: 'Contact', path: '/contact' }
  ];

  // Check if current path matches link
  const isActive = (path) => {
    return location.pathname === path;
  };

  return (
    <nav 
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        isScrolled 
          ? 'bg-slate-900/95 backdrop-blur-sm shadow-lg shadow-purple-500/10' 
          : 'bg-slate-900/80 backdrop-blur-sm'
      }`}
    >
      <div className="container mx-auto px-6 py-4">
        <div className="flex items-center justify-between">
          {/* Logo - Use Link instead of <a> */}
          <Link 
            to="/" 
            className="text-2xl font-bold text-white hover:text-purple-400 transition-colors"
          >
            <span className="text-purple-400">&lt;</span>
            Godfrey
            <span className="text-purple-400">/&gt;</span>
          </Link>

          {/* Desktop Navigation - Use Link instead of <a> */}
          <div className="hidden md:flex items-center space-x-8">
            {navLinks.map((link, index) => (
              <Link
                key={index}
                to={link.path} // ← Use 'to' not 'href'
                className={`transition-colors font-medium relative group ${
                  isActive(link.path) 
                    ? 'text-purple-400' 
                    : 'text-gray-300 hover:text-purple-400'
                }`}
              >
                {link.name}
                <span className={`absolute -bottom-1 left-0 h-0.5 bg-purple-400 
                               transition-all duration-300 ${
                                 isActive(link.path) ? 'w-full' : 'w-0 group-hover:w-full'
                               }`}></span>
              </Link>
            ))}
          </div>

          {/* Mobile Menu Button */}
          <button
            onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
            className="md:hidden text-white focus:outline-none"
            aria-label="Toggle menu"
          >
            <svg
              className="w-6 h-6"
              fill="none"
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth="2"
              viewBox="0 0 24 24"
              stroke="currentColor"
            >
              {isMobileMenuOpen ? (
                <path d="M6 18L18 6M6 6l12 12" />
              ) : (
                <path d="M4 6h16M4 12h16M4 18h16" />
              )}
            </svg>
          </button>
        </div>

        {/* Mobile Menu - Use Link instead of <a> */}
        <div
          className={`md:hidden overflow-hidden transition-all duration-300 ${
            isMobileMenuOpen ? 'max-h-96 mt-4' : 'max-h-0'
          }`}
        >
          <div className="flex flex-col space-y-4 py-4 bg-slate-800 rounded-lg px-4">
            {navLinks.map((link, index) => (
              <Link
                key={index}
                to={link.path} // ← Use 'to' not 'href'
                className={`transition-colors font-medium py-2 border-b border-slate-700 last:border-b-0 ${
                  isActive(link.path)
                    ? 'text-purple-400'
                    : 'text-gray-300 hover:text-purple-400'
                }`}
              >
                {link.name}
              </Link>
            ))}
          </div>
        </div>
      </div>
    </nav>
  );
};

export default Navigation;